import { render, staticRenderFns } from "./DeferredContent.vue?vue&type=template&id=2505ce2c&"
import script from "./DeferredContent.vue?vue&type=script&lang=js&"
export * from "./DeferredContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports